import {Component, inject} from '@angular/core';
import {FiltersSidebarFilterCheckboxesComponent} from './filters-sidebar-filter-checkboxes/filters-sidebar-filter-checkboxes.component';
import {FiltersSidebarSizeFilter} from './filters-sidebar-size-filter/filters-sidebar-size-filter';
import {FiltersSidebarHeader} from './filters-sidebar-header/filters-sidebar-header';
import {Sidebar} from '../../../../shared/components/sidebar/sidebar';
import {ResultTableService} from '../../services/result-table.service';
import { FiltersSidebarWarrantyFilterComponent } from './filters-sidebar-warranty-filter/filters-sidebar-warranty-filter.component';

@Component({
  selector: 'app-filters-sidebar',
  standalone: true,
  imports: [FiltersSidebarFilterCheckboxesComponent, FiltersSidebarSizeFilter, FiltersSidebarHeader, Sidebar, FiltersSidebarWarrantyFilterComponent],
  templateUrl: './filters-sidebar.component.html',
  styleUrl: './filters-sidebar.component.css'
})
export class FiltersSidebarComponent {
  resultTableService = inject(ResultTableService);
}
